// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"35497442","183":"35497442","275":"31a27f37","855":"c2cd06b2"}[chunkId] + ".chunk.css";
};